import { EducatorPageChrome } from "@/pages/educators/page-chrome"
import { useNewProps } from "./page-props"
import { SaveButton } from "@/components/shared/action-buttons"
import { PageBody } from "@/components/ui/layout"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { useId } from "react"
import { useFormSchema } from "./form-schema"
import { ListingFormSchema } from "./validation-schema"
import { useNavigate } from "@/lib/page-rendering"

export default function Page() {
  const navigate = useNavigate()
  const { priorities } = useNewProps()

  const formId = useId()
  const titleId = useId()
  const formSchema = useFormSchema(priorities)

  const handleSubmit = (data: ListingFormSchema) => {
    const instance_index = priorities.find(
      (pr) => pr.uuid === data.priority_uuid,
    )!.instance_index

    navigate({
      href: ".",
      method: "post",
      data: {
        relief_listing: {
          ...data,
          instance_index,
        },
      },
    })
  }

  return (
    <>
      <EducatorPageChrome
        titleId={titleId}
        action={<SaveButton form={formId} />}
      />
      <PageBody>
        <FormRenderer
          schema={formSchema}
          formId={formId}
          titleId={titleId}
          onSubmit={handleSubmit}
          defaultValues={{
            invite_only: "true",
            end_date: null,
            details: {
              tag_ids: [],
            },
          }}
          registerDirtyDraft
        />
      </PageBody>
    </>
  )
}
